export default __webpack_public_path__ + "static/media/Sugarcane.423a3cf3.jpg";